import {faCheckSquare, faMinusSquare} from '@fortawesome/pro-duotone-svg-icons';
import {faSquare as regFaSquare} from '@fortawesome/pro-regular-svg-icons';
import {faSquare} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Checkbox} from '@radix-ui/react-checkbox';

import {style} from '../style';

import type {CheckboxProps} from '@radix-ui/react-checkbox';

type Props = Omit<CheckboxProps, 'children'> &
  React.RefAttributes<HTMLButtonElement> & {
    name: string;
    description?: string;
  };
export function StackedCheckboxGroupItem({
  name,
  description,
  className,
  ...props
}: Props): React.JSX.Element {
  return (
    <Checkbox {...props} className={style.item}>
      <span aria-hidden="true">
        <FontAwesomeIcon
          icon={faCheckSquare}
          className="text-blue11 group-radix-state-checked:inline-block! hidden! h-5 w-5"
          style={{
            ['--fa-primary-color' as string]: 'var(--color-slate1)',
            ['--fa-secondary-color' as string]: !props.disabled
              ? 'var(--color-blue11)'
              : 'var(--color-slate11)',
            ['--fa-secondary-opacity' as string]: '1',
          }}
        />
        <FontAwesomeIcon
          icon={faMinusSquare}
          className="text-blue11 group-radix-state-indeterminate:inline-block! hidden! h-5 w-5"
          style={{
            ['--fa-primary-color' as string]: 'var(--color-slate1)',
            ['--fa-secondary-color' as string]: !props.disabled
              ? 'var(--color-blue11)'
              : 'var(--color-slate11)',
            ['--fa-secondary-opacity' as string]: '1',
          }}
        />

        <span className="fa-layers fa-fw group-radix-state-unchecked:inline-block! hidden!">
          <FontAwesomeIcon
            icon={faSquare}
            className="text-slate1 h-5 w-5"
            transform="shrink-1"
          />
          <FontAwesomeIcon icon={regFaSquare} className="text-slate6 h-5 w-5" />
        </span>
      </span>

      <span className={style.textWrapper}>
        <span className={style.name}>{name}</span>
        {description && (
          <span className={style.description}>{description}</span>
        )}
      </span>
    </Checkbox>
  );
}

StackedCheckboxGroupItem.displayName = 'StackedCheckboxGroupItem';
